<template>
  <div>
    <p>{{$t('contract.signature.headline')}}</p>
    <p class="mt-5">{{$t('contract.signature.date.label')}} &nbsp; _________________________________</p>
    <p class="mt-5">{{$t('contract.signature.company.label')}} &nbsp; _________________________________</p>
    <p class="mt-5">{{$t('contract.signature.employee.label')}} &nbsp; _________________________________</p>
    <p class="mt-5" v-show="displayDisclaimer">{{$t('contract.signature.disclaimer_only_fr_de')}} </p>
  </div>
</template>

<script>
export default {
  computed: {
    displayDisclaimer() {
      let locale = this.$store.state.contract.locale.contractLanguage;
      return locale !== 'da-DK' && locale !== 'en-UK';
    },
  },
};
</script>